import React from 'react';
import {
  Button,
  Text,
  HStack,
} from '@chakra-ui/react';
import Modal, { ModalHeader, ModalTitle, ModalBody, ModalFooter, ModalCloseTrigger } from '@/components/ui/Modal';

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  isLoading?: boolean;
  type?: 'danger' | 'warning' | 'info';
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Confirm Action",
  message = "Are you sure you want to proceed?",
  confirmText = "Confirm",
  cancelText = "Cancel",
  isLoading = false,
  type = 'danger',
}) => {
  const getColorScheme = () => {
    switch (type) {
      case 'danger':
        return 'red';
      case 'warning':
        return 'orange';
      case 'info':
        return 'blue';
      default:
        return 'red';
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm">
      <ModalHeader>
        <ModalTitle
          color={`${getColorScheme()}.700`} 
          _dark={{ color: `${getColorScheme()}.300` }}
          fontSize="md"
          fontWeight="semibold"
        >
          {title}
        </ModalTitle>
        <ModalCloseTrigger />
      </ModalHeader>
      
      <ModalBody>
        <Text color={`${getColorScheme()}.600`} _dark={{ color: `${getColorScheme()}.300` }}>
          {message}
        </Text>
      </ModalBody>
      
      <ModalFooter>
        <HStack justify="end" gap={3}>
          <Button 
            variant="outline" 
            size="sm" 
            onClick={onClose}
            disabled={isLoading}
          >
            {cancelText}
          </Button>
          <Button
            loading={isLoading}
            colorPalette={getColorScheme()}
            onClick={onConfirm}
          >
            {confirmText}
          </Button>
        </HStack>
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmationModal; 